export enum PollingInstanceType {
  COPY_TO_CASTIT = 'CopyToCastIt',
  COPY_TO_CASTIT_STUDIO = 'CopyToCastItStudio',
}

export enum PollingInstanceStatus {
  NONE = 'none',
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
  PARTIAL_SUCCESS = 'partial-success',
}

export type PollingInstance = {
  id: string;
  type: PollingInstanceType;
  status: PollingInstanceStatus;
};

/** the handler for a polling instance check should take the instance and return an updated instance with the current status */
export type PollingHandler = (params: { instance: PollingInstance }) => Promise<PollingInstance>;
